// this file will have all the variables that are reuseable across the project.  If you need to make one change, it propagates throughout.

// the API url is re-used in search data, uploading a recipe to the server, etc.  But what if the url changes, like v3?  That's why it has to be here.
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = '220df835-1a45-4239-a9ba-a55de96b4b6b';
export const MODAL_CLOSE_SEC = 2.5;
